import { Box, FormControl } from "@primer/react";
import NumberBox from "devextreme-react/number-box";
import RadioGroup from "devextreme-react/radio-group";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { ComboboxNamHoc } from "../../components/combobox-namhoc";
import SearchHocsinh from "../../components/search-hocsinh";
import SelectBoxMultipleHinhThucNopBom from "../../components/selectbox-multiple-hinhthucnopbom";
import Button from "../../components/ui/button";
import Modal from "../../components/ui/modal";
import ModalActions from "../../components/ui/modal/ModalActions";
import Text from "../../components/ui/text";
import TextInput from "../../components/ui/text-input";
import {
  sf_hachtoan_congno,
  sf_hachtoan_congno_viewmodel,
} from "../../models/response/hach-toan-cong-no/sf_hachtoan_congno";
import { ts_hocsinh_viewmodel } from "../../models/response/hocsinh/ts_hocsinh";
import { loadKhoanNopStart } from "../../state/actions/khoanNopActions";
import { RootState } from "../../state/reducers";
type HachToanCongNoDetailModalProps = {
  title: string;
  sf_hachtoan_congno?: sf_hachtoan_congno_viewmodel;
  onClose: () => void;
  onSubmit: (data: sf_hachtoan_congno) => void;
  is_saving?: boolean;
  animationOf: string;
  nam_hoc?: string;
  dm_truong_id?: number;
  ts_hocsinh?: ts_hocsinh_viewmodel;
  con_du?: number;
  sf_mucphaithu_root_id?: number;
};
const createDataObject = (
  entries: [number, number][]
): Record<number, number> => {
  return Object.fromEntries(entries);
};

const dataObject = createDataObject([
  [9, 1],
  [10, 2],
  [11, 3],
  [12, 4],
  [13, 5],
  [14, 6],
  [15, 7],
  [16, 8],
  [17, 9],
  [18, 10],
  [7, 11],
  [8, 12],
  [2, 13],
  [3, 14],
  [1, 15],
]);
const HachToanCongNoEditModal = (props: HachToanCongNoDetailModalProps) => {
  const dispatch = useDispatch();
  const { dm_coso_id } = useSelector((x: RootState) => x.common);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<sf_hachtoan_congno_viewmodel>({
    defaultValues: props.sf_hachtoan_congno ?? {
      id: 0,
      is_da_thanh_toan: false,
      is_hoan_tra: true,
      nam_hoc: props.nam_hoc || "",
      noi_dung: "",
      sf_mucphaithu_id: 0,
      sf_tbtp_id: 0,
      tong_tien: 0,
      ts_hocsinh_id: 0,
      ho_ten: "",
      ma_hs: "",
      ten_he: "",
      ten_khoi: "",
      ten_lop: "",
      ten_truong: "",
      sf_hoanphi_type_id: 0,
      sf_hinhthucnopbom_ids: "1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18",
      sf_mucphaithu_root_id: 0,
    },
  });
  useEffect(() => {
    dispatch(loadKhoanNopStart());
  }, []);
  const onSubmit = async (data: any) => {
    props.onSubmit({
      ...data,
      dm_coso_id: dm_coso_id,
    });
  };

  return (
    <Modal
      isOpen
      title={props.sf_hachtoan_congno ? "Cập nhật" : "Thêm mới"}
      onClose={() => {
        props.onClose();
      }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box>
          <FormControl>
            <FormControl.Label>Năm học</FormControl.Label>
            <Controller
              control={control}
              name="nam_hoc"
              rules={{
                required: {
                  value: true,
                  message: "Vui lòng chọn năm học",
                },
              }}
              render={({ field }) => (
                <ComboboxNamHoc
                  value={field.value}
                  onValueChanged={(value) => field.onChange(value)}
                  isReadonly={props.ts_hocsinh !== undefined}
                />
              )}
            />
            {errors?.["nam_hoc"] && (
              <FormControl.Validation variant="error">
                Vui lòng chọn năm học
              </FormControl.Validation>
            )}
          </FormControl>
        </Box>
        <Box sx={{ mb: 2 }}>
          <FormControl>
            <FormControl.Label>Học sinh</FormControl.Label>
            <Controller
              control={control}
              name="ts_hocsinh_id"
              rules={{
                required: {
                  value: true,
                  message: "Vui lòng chọn học sinh",
                },
              }}
              render={({ field: fieldId }) => (
                <Controller
                  control={control}
                  name="ho_ten"
                  render={({ field: fieldName }) => (
                    <SearchHocsinh
                      defaultValue={fieldName.value}
                      onResultChanged={(ts_hocsinh: any) => {
                        fieldId.onChange(ts_hocsinh ? ts_hocsinh.id : null);
                        fieldName.onChange(ts_hocsinh ? ts_hocsinh.ho_ten : "");
                      }}
                      dm_truong_id={props.dm_truong_id}
                    />
                  )}
                />
              )}
            />
            {errors?.["ts_hocsinh_id"] && (
              <FormControl.Validation variant="error">
                Vui lòng chọn học sinh
              </FormControl.Validation>
            )}
          </FormControl>
        </Box>
        <Box sx={{ mb: 2 }}>
          <FormControl>
            <FormControl.Label>
              <Text text="Nội dung" />
            </FormControl.Label>
            <TextInput
              block
              name="noi_dung"
              register={register}
              errors={errors}
              required
              validateMessage={`Vui lòng điền nội dung`}
            />
          </FormControl>
        </Box>
        <Box sx={{ mb: 2 }}>
          <FormControl>
            <FormControl.Label>
              <Text text="Tổng tiền" />
            </FormControl.Label>
            <Controller
              control={control}
              name="tong_tien"
              rules={{
                required: {
                  value: true,
                  message: "Vui lòng nhập tổng tiền",
                },
              }}
              render={({ field }) => (
                <NumberBox
                  width={"100%"}
                  stylingMode="outlined"
                  format={",##0"}
                  value={field.value}
                  onValueChanged={(e) => field.onChange(e.value)}
                  disabled={props.ts_hocsinh !== undefined}
                />
              )}
            />
          </FormControl>
        </Box>
        <Box sx={{ mb: 2 }}>
          <FormControl>
            <FormControl.Label>Áp dụng cho kỳ nộp</FormControl.Label>
            <Controller
              control={control}
              name="sf_hinhthucnopbom_ids"
              rules={{
                required: {
                  value: false,
                  message: "",
                },
              }}
              render={({ field }) => (
                <SelectBoxMultipleHinhThucNopBom
                  value={
                    typeof field.value === "string"
                      ? field.value.split(",").map((x) => parseInt(x, 10) || 0)
                      : Array.isArray(field.value)
                      ? field.value
                      : []
                  }
                  onValueChanged={(values) => {
                    field.onChange(values.join(","));
                  }}
                  isShowClearBtn={true}
                />
              )}
            />
          </FormControl>
        </Box>

        <Box>
          <FormControl>
            <FormControl.Label>Loại quyết toán</FormControl.Label>
            <Controller
              control={control}
              name="is_hoan_tra"
              rules={{ required: false }}
              render={({ field }) => (
                <RadioGroup
                  items={["Hoàn trả", "Thu bổ sung"]}
                  value={
                    field.value === undefined
                      ? null
                      : field.value
                      ? "Hoàn trả"
                      : "Thu bổ sung"
                  }
                  onValueChanged={(e) => {
                    field.onChange(e.value === "Hoàn trả"); // Chuyển thành boolean
                  }}
                  layout="horizontal"
                  disabled={props.ts_hocsinh !== undefined}
                />
              )}
            />
          </FormControl>
        </Box>
        {/* <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 3, mb: 2 }}>
                    <Box>
                        <FormControl>
                            <FormControl.Label>Áp dụng</FormControl.Label>
                            <Controller
                                control={control}
                                name="is_active"
                                rules={{
                                    required: {
                                        value: false,
                                        message: ""
                                    }
                                }}
                                render={({ field }) => (
                                    <Checkbox checked={field.value}
                                        onChange={(e) => {
                                            field.onChange(e.target.checked)
                                        }}
                                    />
                                )}
                            />
                        </FormControl>
                    </Box>

                    <Box>
                        <FormControl>
                            <FormControl.Label>Thu đầu vào</FormControl.Label>
                            <Controller
                                control={control}
                                name="thu_dau_vao"
                                rules={{
                                    required: {
                                        value: false,
                                        message: ""
                                    }
                                }}
                                render={({ field }) => (
                                    <Checkbox checked={field.value}
                                        onChange={(e) => {
                                            field.onChange(e.target.checked)
                                        }}
                                    />
                                )}
                            />
                        </FormControl>
                    </Box>
                    <Box>
                        <FormControl>
                            <FormControl.Label>Khoản tạm thu</FormControl.Label>
                            <Controller
                                control={control}
                                name="is_khoan_tam_thu"
                                rules={{
                                    required: {
                                        value: false,
                                        message: ""
                                    }
                                }}
                                render={({ field }) => (
                                    <Checkbox checked={field.value}
                                        onChange={(e) => {
                                            field.onChange(e.target.checked)
                                        }}
                                    />
                                )}
                            />
                        </FormControl>
                    </Box>
                </Box> */}
        <ModalActions>
          <Button
            text="Đóng"
            onClick={() => {
              props.onClose();
            }}
          />
          <Button text="Cập nhật" variant="primary" type="submit" />
        </ModalActions>
      </form>
    </Modal>
  );
};

export default HachToanCongNoEditModal;
